module.exports = __webpack_public_path__ + "static/media/instagram@2x.2eef07a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/redes/instagram@2x.png
// module id = 237
// module chunks = 0